var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedinIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80,99.74H20C9.12,99.74,.26,90.88,.26,80V20C.26,9.12,9.12,.26,20,.26h60c10.88,0,19.74,8.85,19.74,19.74v60c0,10.88-8.85,19.74-19.74,19.74ZM20,9.74c-5.66,0-10.26,4.6-10.26,10.26v60c0,5.66,4.6,10.26,10.26,10.26h60c5.66,0,10.26-4.6,10.26-10.26V20c0-5.66-4.6-10.26-10.26-10.26H20Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24.77,28.72c0-3.16,2.5-5.38,5.96-5.38s5.96,2.22,5.96,5.38-2.5,5.38-5.96,5.38-5.96-2.25-5.96-5.38Zm.8,10.46h10.29v34.73h-10.29V39.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.88,39.18h8.4l.74,4.4h.26c2.92-2.81,6.42-5.24,11.16-5.24,7.55,0,10.77,5.33,10.77,14.01v21.56h-10.29v-20.24c0-5-1.34-6.56-4.31-6.56-2.59,0-4.17,1.2-6.43,3.38v23.43h-10.29V39.18Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-icon.20caaa079b981805680799d161ca7405.svg";
export { ForwardRef as ReactComponent };